module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_302948.fd29a205.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/FormatoSimplificado_302948.pdf
// module id = 813
// module chunks = 0